module.exports = __webpack_public_path__ + "img/ic_play.441cab2a.svg";